export default __webpack_public_path__ + "static/media/Ubuntu-Medium.111af58d.woff2";